import { z } from 'zod';

import { chatMessageIdSchema, chatThreadIdSchema } from '~/shared/data-contract/chat/chat-ids';

export const chatFeedbackSentimentSchema = z.enum(['positive', 'negative']);
export type ChatFeedbackSentiment = z.infer<typeof chatFeedbackSentimentSchema>;

export const chatFeedbackWireSentimentSchema = z.enum(['POSITIVE', 'NEGATIVE']);
export type ChatFeedbackWireSentiment = z.infer<typeof chatFeedbackWireSentimentSchema>;

export const positiveChatFeedbackTags = [
    'task_resolved',
    'request_followed',
    'useful_job_architecture_context',
    'useful_skill_context',
    'clear_actionable',
    'other',
] as const;

export const negativeChatFeedbackTags = [
    'incorrect_incomplete',
    'request_not_followed',
    'wrong_scope',
    'lost_context',
    'missing_job_or_skill_context',
    'other',
] as const;

export const positiveChatFeedbackTagSchema = z.enum(positiveChatFeedbackTags);
export const negativeChatFeedbackTagSchema = z.enum(negativeChatFeedbackTags);
export const chatFeedbackTagSchema = z.union([positiveChatFeedbackTagSchema, negativeChatFeedbackTagSchema]);
export type ChatFeedbackTag = z.infer<typeof chatFeedbackTagSchema>;

export const chatFeedbackRequestSchema = z
    .object({
        agentResponse: z
            .object({
                message: z.string(),
                messageId: chatMessageIdSchema,
            })
            .strict(),
        feedback: z.discriminatedUnion('sentiment', [
            z
                .object({
                    quickFeedback: z.array(positiveChatFeedbackTagSchema).min(1),
                    sentiment: z.literal('POSITIVE'),
                    userComment: z.string().nullable(),
                })
                .strict(),
            z
                .object({
                    quickFeedback: z.array(negativeChatFeedbackTagSchema).min(1),
                    sentiment: z.literal('NEGATIVE'),
                    userComment: z.string().nullable(),
                })
                .strict(),
        ]),
        occurredAt: z.iso.datetime(),
        threadId: chatThreadIdSchema,
    })
    .strict();

export type ChatFeedbackRequest = z.infer<typeof chatFeedbackRequestSchema>;
